import { defineMessages } from 'react-intl'

export const subscriptionDetailsMessages = defineMessages({
  title: {
    id: 'subscriptionDetails.title',
    description: 'Title for a block with subscription details',
    defaultMessage: 'Subscription Details',
  },
  backLink: {
    id: 'subscriptionDetails.backLink',
    description: 'Link button to back to "Subscription" page',
    defaultMessage: 'Back to Subscription',
  },
})
